<template>
  <div id="PrintSessionView31_1">
    <div v-if="PrintSessionShow" class="well" style="padding: 0 1em">
      <br style="text-align: left; padding: 0.5rem 2rem">
        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="endpickrInstance"
            ></flat-pickr>
          </div>
          
            <div style="margin-left: 10px">
              單位：<br />
              <select v-model="queryInfo.option1Value" style="width:150px;" >
                <option
                  v-for="item in options3"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>

            <div style="margin-left: 10px">
                宣導類型：<br /> 
                <select v-model="queryInfo.activeClassSn" style="width:150px;">
                  <option v-for="item in activeClassOptions" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
             </div>

          <button
            href="#"
            @click.prevent="getALLSessionList(queryInfo.option1Value)"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>
          <button
            href="#"
            @click.prevent="reset()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            清除重來
          </button>

       <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(queryInfo.option1Value)
                .concat('/')
                .concat(queryInfo.updateUserName)
                .concat('/')
                .concat(queryInfo.activeClassSn)"
            v-show="total > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
             
</div>
<br>
        活動日期起迄：{{ queryInfo.sActiveTime + "-" + queryInfo.eActiveTime }}<br>
        目前高中職招生宣導活動共 {{ total }}筆
      </div>



            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
           
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
                .concat('/')
                .concat(queryInfo.activeClassSn)"
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
 

</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "PrintSessionView31_1",
  data() {
    return {
      id: this.$store.getters.getAllstate.user.id,
      dptcd: this.$store.getters.getAllstate.user.dptcd,
      gid: this.$store.getters.getAllstate.user.gid,
      name: this.$store.getters.getAllstate.user.name,
      dptnm: this.$store.getters.getAllstate.user.dptnm,
      sActiveTime:"2025-01-01",
      eActiveTime:"2025-01-01",
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      PrintSessionShow: false,
      activeClassOptions: [{ value: "", text: "請選擇宣導類型" }],


      options1: [{ value: 1, text: "個人查詢" }],
     options2: [
        { value: "", text: "請選擇系所" },
        { value: 19, text: "化材系" },
        { value: 25, text: "冷凍系" },
        { value: 46, text: "智動系" },
        { value: 22, text: "機械系" },
        { value: 47, text: "智慧系" },
        { value: 40, text: "資工系" },
        { value: 14, text: "電子系" },
        { value: 11, text: "電機系" },
        { value: 16, text: "工管系" },
        { value: 27, text: "企管系" },
        { value: 33, text: "健康系" },
        { value: 26, text: "行流系" },
        { value: 38, text: "資管系" },
        { value: 24, text: "景觀系" },
        { value: 32, text: "文創系" },
        { value: 35, text: "應英系" },
      
       // { value: 29, text: "前瞻電資科技研究所" },
       // { value: 30, text: "智慧製造與資訊應用國際碩士學位學程" },

      ],
      options3: [
        { value: 1, text: "學院" },
        { value: 2, text: "教學單位" },
      //  { value: 3, text: "行政單位" },
      //  { value: 4, text: "系主任" },
        { value: 5, text: "化材系" },
        { value: 6, text: "冷凍系" },
        { value: 7, text: "智動系" },
        { value: 8, text: "機械系" },
        { value: 9, text: "智慧系" },
        { value: 10, text: "資工系" },
        { value: 11, text: "電子系" },
        { value: 12, text: "電機系" },
        { value: 13, text: "工管系" },
        { value: 14, text: "企管系" },
        { value: 15, text: "健康系" },
        { value: 16, text: "行流系" },
        { value: 17, text: "資管系" },
        { value: 18, text: "景觀系" },
        { value: 19, text: "文創系" },
        { value: 20, text: "應英系" },
        
        { value: 22, text: "招生處" },
        { value: 23, text: "校長室" },
        { value: 24, text: "秘書室" },
        { value: 25, text: "推廣部" },
        { value: 26, text: "教務處" },
        { value: 27, text: "體育室" },
        { value: 28, text: "精密製造科技研究所" },
        { value: 29, text: "前瞻電資科技研究所" },
        { value: 30, text: "智慧製造與資訊應用國際碩士學位學程" },

      ],
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected1: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        defaultDate: "2025-01-01", // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        activeClassSn: 0,   // 宣導類型
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
        options2Value: 1,
        option1Value:1,
        functionValue:1 // EIP統計 1需要;其他號碼:不需要只用來區別

      },
    };
  },
  components: {
    flatPickr,
  },
  methods: {

    checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.queryInfo.sActiveTime)) {
        alert("請選擇活動開始日期");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.queryInfo.eActiveTime)) {
        alert("請選擇活動結束日期");
        this.inputFlag = true;
        return;
      }
         

    },
    getActiveTime() {
      let vm = this;
      if (tools.empty(vm.queryInfo.sActiveTime)) {
        vm.queryInfo.sActiveTime = vm.flatpickrConfig.default;
      }
      if (tools.empty(vm.queryInfo.eActiveTime)) {
        vm.queryInfo.eActiveTime = vm.flatpickrConfig.default;
      }

      if (!tools.empty(vm.queryInfo.sActiveTime)) {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
        // 提取日期部分
        vm.queryInfo.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (!tools.empty(vm.queryInfo.eActiveTime)) {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
        // 提取日期部分
        vm.queryInfo.eActiveTime = dateObject.toISOString().split("T")[0];
      }
    },
    reset() {
      let vm = this;
      vm.queryInfo = {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
        options2Value: 1,
        activeClassSn: 0,   // 宣導類型
        option1Value:1
      };
      vm.PrintSessionShow = true;

    },
    
    loadActiveClassOptions() {
  this.$http
    .get("./WebApi/HighSchoolEnrolling/GetActiveClassOptions/")
    .then((response) => {
      this.activeClassOptions = [
        { value: 0, text: "全部" },
        ...response.data
      ];
    })
    .catch((error) => {
      alert("載入宣導類型失敗：" + error);
    });
},
    getALLSessionList6() {
      let vm = this;
      vm.checkInput();

      if (vm.inputFlag != true) {


      vm.currentPage = vm.queryInfo.options1Value - 1;
      //vm.queryInfo.sActiveTime=vm.sActiveTime;
      //vm.queryInfo.eActiveTime=vm.eActiveTime;
      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList6/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            vm.total2 = response.data.length;
            console.log("vm.inputData2", vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    }
  },

  getDepName(dptcd) {
      let vm = this;

   //var dptcd=vm.$store.getters.getAllstate.user.dptcd ;
      this.$http
          .get('./WebApi/HighSchoolEnrolling/GetDepName/'.concat(dptcd))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
           

           // console.log("vm.inputData", vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });

  },

 getALLSessionList(options1value) {
      let vm = this;
      vm.queryInfo.options1value=options1value;
      //vm.queryShow=true;
    //  vm.currentPage = vm.queryInfo.options1Value - 1;

      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            console.log("vm.inputData", vm.inputData);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

  },



  created() {
    console.log("======created PrintSessionView31 =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;

    //  console.log(this.$store.getters.getAllstate.user) ;
    let vm = this;
    vm.PrintSessionShow = true;
    this.loadActiveClassOptions();
    //  vm.getALLSessionList();
    //vm.getDepName();
   // vm.getALLSessionList3();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
